import React, {useState, useEffect} from "react";
import { useSearchParams, useLocation, useParams } from "react-router-dom";
import AppBar from "../components/app_bar/AppBar";
import Drawer from "../components/Drawer";
import { 
    Typography, Toolbar, Box, CssBaseline, Grid, Pagination, useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import OrganizationCard from '../components/organization/OrganizationCard';
import OrganizationCardSkeleton from "../components/organization/OrganizationCardSkeleton";
import OrganizationFilter from "../components/organization/OrganizationFilter";

import { GetRecordDisplayed } from '../commonFunctions';
import * as CONSTANTS from "../constants"

import { view_organizations } from "../services/topic_view";

const OrganizationPage = () => {
    
    const location = useLocation();

    let {lang} = useParams();

    document.title = `${CONSTANTS.DRAWER.ORGANIZATION[lang]} - Wotagei Zone`

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));  // Mobile detection

    // hook
    const [maxPage, setMaxPage] = useState(1);
    const [maxRecords, setMaxRecords] = useState(0);
    const [page, setPage] = useState(1);

    // Load Params from URL
    const [searchParams, setSearchParams] = useSearchParams({
        'page': 1,
    });

    const [drawerOpen, setDrawerOpen] = useState(false);
        
    const handleDrawerOpen = (open) => {
        if (open === undefined) {
            setDrawerOpen(!drawerOpen)
        } else {
            setDrawerOpen(open);
        }
    }
    
    const handlePageChange = (event, curPage) => {
        searchParams.set('page', curPage)
        let filter = searchParams;
        setPage(curPage);
        setSearchParams(filter);
    };

    const [organizations, setOrganizations] = useState(null);

    // Filter button
    const resetFilter = () => {
        let tempParams = {
            'page': 1,
        }
        setSearchParams(tempParams);
    }

    const submitFilter = (filter) => {
        setSearchParams(filter);
    }

    const fetchOrganizations = async () => {
        try {
            const [status, result] = await view_organizations(lang, searchParams);
            if (status === 200) {
                setOrganizations(result.organizations);
                setMaxRecords(result.records_count);
                setMaxPage(
                    Math.ceil(result.records_count / 10)
                );
            }
        } catch (error) {
            console.error('Failed to fetch organizations.');
        }
    }

    // send api request for url changes
    useEffect(() => {
        fetchOrganizations();
    }, [location.pathname, location.search]);

    return (
        <Box>
            <CssBaseline />
            <AppBar lang={lang} handleDrawerOpen={handleDrawerOpen}/>
            <Box sx={{ display: 'flex' }}>
                <Drawer lang={lang} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
                <Box component="main" sx={{ flexGrow: 1, p: isMobile? 2: 3 }}>
                    <Toolbar />
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={8}>
                            <Typography 
                                variant="h5" 
                                style={{
                                    textAlign: "left",
                                    fontWeight: "bolder",
                                }}
                            >
                                {CONSTANTS.DRAWER.ORGANIZATION[lang].toUpperCase()}
                            </Typography>
                            <Box 
                                pt={3} pb={3}
                            >
                                <Typography>
                                    {organizations? GetRecordDisplayed(lang, maxRecords, page): ''}
                                </Typography>
                            </Box>

                            {/** Load Organzation in a Grid as Cards */}
                            <Box pb={3}>
                                <Grid container spacing={3} >
                                    {
                                        organizations?
                                        (organizations.map((organization) => (
                                            <Grid item xs={12} md={6}>
                                                <OrganizationCard organization={organization} lang={lang}/>
                                            </Grid>
                                        )))
                                        :
                                        <>
                                            <Grid item xs={12} md={6}>
                                                <OrganizationCardSkeleton />
                                            </Grid>
                                            {isMobile? 
                                                <></>
                                                :
                                                <Grid item xs={12} md={6}>
                                                    <OrganizationCardSkeleton />
                                                </Grid>
                                            }
                                        </>
                                    }
                                </Grid>
                            </Box>

                            {/** Pagination */}
                            <Box 
                                display="flex" 
                                justifyContent="center"
                            >
                                <Pagination 
                                    count={maxPage} 
                                    shape="rounded" 
                                    showFirstButton
                                    showLastButton
                                    page={page}
                                    onChange={handlePageChange}
                                />
                            </Box>
                        </Grid>
                        {/** Filters */}
                        <Grid item xs={12} md={4} style={{height: '80vh'}}>
                            <Box >
                                <Typography 
                                    pb={3}
                                    variant="h5" 
                                    style={{
                                        textAlign: "left",
                                        fontWeight: "bolder",
                                    }}
                                >
                                    {CONSTANTS.WAZAREN_FILTER.FILTER[lang].toUpperCase()}
                                </Typography>
                            </Box>
                            <Box pb={3}>
                                <OrganizationFilter resetFilter={resetFilter} submitFilter={submitFilter} lang={lang}/>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Box>
    );
};
 
export default OrganizationPage;